import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
import { getLoggedUser } from 'src/helper/localStore/getLoggedUser'
class CommentsService {
  async getCommentsById(id:number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/comments/?item_id=${id}`, {
        headers: { 'authentication-token': getJWT()!},
      })
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async postComment(item_id:number, message:string): Promise<any> {
    const body = {
        message,
        item_id
    }
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/comments/`,body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editComment(comment_id:number,item_id:number, message:string): Promise<any> {
    const body = {
        message,
        item_id
    }
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/comments/${comment_id}`,body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteComment(comment_id:number): Promise<any> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/comments/${comment_id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const commentsService = new CommentsService()